module.exports = "# Level Completed\n\n## Content\n\n### Welcome back!\n* Use the **OVERVIEW** to go back to any Level and check out the videos in the\n**FUN** section!\n\n## Notes\n\nWelcome back!\n"


//////////////////
// WEBPACK FOOTER
// ./programs/h2whoaHybrid/levelCompleted.md
// module id = 1717
// module chunks = 2